
    // IMPORTS
    import { computed, defineComponent, onMounted, ref } from 'vue'

    import myGrid from '@/components/grid/my-grid.vue'

    import { AccountApi, buildLocalization, Converter } from '@/util'
    import { SortDescriptor } from '@progress/kendo-data-query'
    import { GridColumnProps } from '@progress/kendo-vue-grid'
    import { IPartnerAccountFullDTO } from '@/types/partnerAccount'


    interface IPartnerRow extends IPartnerAccountFullDTO {
        userCount: number,
        language: string
    }

    export default defineComponent({
        name: 'adminPartnerList',

        components: {
            myGrid
        },

        setup() {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/

            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const allPartners = ref<IPartnerRow[] | null>(null)

            const publicData = { allPartners }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const initialSort = computed<SortDescriptor[]>(() => [{ field: 'companyName', dir: 'asc' }])

            const columns = computed(() => {
                {
                    return [
                        {
                            field: 'accountNo',
                            title: localize('Account'),
                            locked: true,
                            width: 150
                        },
                        {
                            field: 'companyName',
                            title: localize('Company'),
                            locked: true,
                            width: 400
                        },
                        {
                            field: 'currency',
                            title: localize('Currency'),
                            width: 150
                        },
                        {
                            field: 'language',
                            title: localize('Language'),
                            width: 150
                        },
                        {
                            field: 'userCount',
                            title: `#${localize('Users')}`,
                            filter: 'numeric',
                            width: 150
                        },
                        {
                            field: 'equipmentsSold',
                            title: `#${localize('EquipmentsSold')}`,
                            filter: 'numeric',
                            width: 150
                        },
                    ] as GridColumnProps[]
                }
            })

            const computedData = { initialSort, columns }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            const publicMethods = { localize }

            /********************************************************************************************************************
             PRIVATE METHODS
             ********************************************************************************************************************/
            function loadPartners() {
                const api = new AccountApi

                api.getPartnerList()
                    .then(response => setPartners(response.data))
            }

            function setPartners(partners: IPartnerAccountFullDTO[]) {
                let result: IPartnerRow[] = []

                for (const partner of partners) {
                    result.push({
                        ...partner,
                        userCount: partner.users.length,
                        language: Converter.languageCodeToLanguage(partner.languageCode, localize)
                    })
                }

                allPartners.value = result
            }

            /********************************************************************************************************************
             LIFE-CYCLE HOOKS
             ********************************************************************************************************************/
            onMounted(() => loadPartners())

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
